
import { computed, defineComponent, PropType } from 'vue'
import { addDays, candidatesLabel, formatShortDate, plural } from '../helpers'
import { DayKey, HotWindowsTaskType } from '../types'
import HwIcon from './HwIcon.vue'

export default defineComponent({
    name: 'HotWindowsDayCard',
    components: { HwIcon },
    props: {
        dayKey: { type: String as PropType<DayKey>, required: true },
        date: { type: String, required: true },
        active: { type: Boolean, default: false },
        activeTask: { type: String as PropType<HotWindowsTaskType | null>, default: null },
        windowCount: { type: Number, default: 0 },
        counts: { type: Object as PropType<Record<HotWindowsTaskType, number>>, required: true },
        loading: { type: Boolean, default: false },
    },
    emits: ['select'],
    setup(props) {
        return {
            tasks: computed(() => [
                {
                    id: 'transfer' as HotWindowsTaskType,
                    icon: 'repeat',
                    sub:
                        props.dayKey === 'today'
                            ? 'Клиенты уже записаны на завтра'
                            : 'Клиенты уже записаны на послезавтра',
                },
                { id: 'base' as HotWindowsTaskType, icon: 'calendar-plus', sub: 'Клиент сейчас никуда не записан' },
            ]),
            shortDate: computed(() => formatShortDate(props.date)),
            // Переносим с записи на следующий день: функция берёт кандидатов
            // transfer из записей reference_date + 1.
            fromDate: computed(() => formatShortDate(addDays(props.date, 1))),
            windowWord: computed(() => plural(props.windowCount, 'окно', 'окна', 'окон')),
            candidateWord: (count: number) => plural(count, 'кандидат', 'кандидата', 'кандидатов'),
            candidatesLabel,
        }
    },
})
